import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Inventory = () => {
  const [products, setProducts] = useState([]);
  const [stock, setStock] = useState([]);
  const [procurements, setProcurements] = useState([]);
  const [productForm, setProductForm] = useState({
    name: '',
    category: 'medication',
    description: '',
    unitPrice: 0,
    supplier: '',
  });
  const [stockForm, setStockForm] = useState({
    productId: '',
    quantity: 0,
    minQuantity: 0,
    location: '',
  });
  const [procurementForm, setProcurementForm] = useState({
    productId: '',
    quantity: 0,
    supplier: '',
    totalCost: 0,
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [productsRes, stockRes, procurementsRes] = await Promise.all([
        axios.get(`${window.location.protocol}//${window.location.hostname}/api/inventory/products`),
        axios.get(`${window.location.protocol}//${window.location.hostname}/api/inventory/stock`),
        axios.get(`${window.location.protocol}//${window.location.hostname}/api/inventory/procurement`),
      ]);
      setProducts(productsRes.data);
      setStock(stockRes.data);
      setProcurements(procurementsRes.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleProductSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${window.location.protocol}//${window.location.hostname}/api/inventory/products`, productForm);
      setProductForm({
        name: '',
        category: 'medication',
        description: '',
        unitPrice: 0,
        supplier: '',
      });
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  const handleStockSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${window.location.protocol}//${window.location.hostname}/api/inventory/stock`, stockForm);
      setStockForm({
        productId: '',
        quantity: 0,
        minQuantity: 0,
        location: '',
      });
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  const handleProcurementSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${window.location.protocol}//${window.location.hostname}/api/inventory/procurement`, procurementForm);
      setProcurementForm({
        productId: '',
        quantity: 0,
        supplier: '',
        totalCost: 0,
      });
      fetchData();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <h2>Inventory</h2>
      <h3>Add Product</h3>
      <form onSubmit={handleProductSubmit}>
        <input name="name" placeholder="Product Name" value={productForm.name} onChange={(e) => setProductForm({ ...productForm, name: e.target.value })} required />
        <select name="category" value={productForm.category} onChange={(e) => setProductForm({ ...productForm, category: e.target.value })}>
          <option value="medication">Medication</option>
          <option value="equipment">Equipment</option>
          <option value="supplies">Supplies</option>
          <option value="imaging">Imaging</option>
        </select>
        <textarea name="description" placeholder="Description" value={productForm.description} onChange={(e) => setProductForm({ ...productForm, description: e.target.value })}></textarea>
        <input name="unitPrice" type="number" placeholder="Unit Price" value={productForm.unitPrice} onChange={(e) => setProductForm({ ...productForm, unitPrice: parseFloat(e.target.value) })} required />
        <input name="supplier" placeholder="Supplier" value={productForm.supplier} onChange={(e) => setProductForm({ ...productForm, supplier: e.target.value })} />
        <button type="submit">Add Product</button>
      </form>
      <h3>Add Stock</h3>
      <form onSubmit={handleStockSubmit}>
        <select name="productId" value={stockForm.productId} onChange={(e) => setStockForm({ ...stockForm, productId: e.target.value })} required>
          <option value="">Select Product</option>
          {products.map(product => (
            <option key={product.id} value={product.id}>{product.name}</option>
          ))}
        </select>
        <input name="quantity" type="number" placeholder="Quantity" value={stockForm.quantity} onChange={(e) => setStockForm({ ...stockForm, quantity: parseInt(e.target.value) })} required />
        <input name="minQuantity" type="number" placeholder="Min Quantity" value={stockForm.minQuantity} onChange={(e) => setStockForm({ ...stockForm, minQuantity: parseInt(e.target.value) })} />
        <input name="location" placeholder="Location" value={stockForm.location} onChange={(e) => setStockForm({ ...stockForm, location: e.target.value })} />
        <button type="submit">Add Stock</button>
      </form>
      <h3>Add Procurement</h3>
      <form onSubmit={handleProcurementSubmit}>
        <select name="productId" value={procurementForm.productId} onChange={(e) => setProcurementForm({ ...procurementForm, productId: e.target.value })} required>
          <option value="">Select Product</option>
          {products.map(product => (
            <option key={product.id} value={product.id}>{product.name}</option>
          ))}
        </select>
        <input name="quantity" type="number" placeholder="Quantity" value={procurementForm.quantity} onChange={(e) => setProcurementForm({ ...procurementForm, quantity: parseInt(e.target.value) })} required />
        <input name="supplier" placeholder="Supplier" value={procurementForm.supplier} onChange={(e) => setProcurementForm({ ...procurementForm, supplier: e.target.value })} required />
        <input name="totalCost" type="number" placeholder="Total Cost" value={procurementForm.totalCost} onChange={(e) => setProcurementForm({ ...procurementForm, totalCost: parseFloat(e.target.value) })} required />
        <button type="submit">Add Procurement</button>
      </form>
      <h3>Products</h3>
      <ul>
        {products.map(product => (
          <li key={product.id}>{product.name} - {product.category} - ${product.unitPrice}</li>
        ))}
      </ul>
      <h3>Stock</h3>
      <ul>
        {stock.map(item => (
          <li key={item.id}>Product {item.productId} - Quantity: {item.quantity} - Location: {item.location}</li>
        ))}
      </ul>
      <h3>Procurements</h3>
      <ul>
        {procurements.map(proc => (
          <li key={proc.id}>Product {proc.productId} - Quantity: {proc.quantity} - Supplier: {proc.supplier} - Cost: ${proc.totalCost}</li>
        ))}
      </ul>
    </div>
  );
};

export default Inventory;